
<template>
  <el-container class="pagination-list doing-task">
    <el-main>
      <div class="content">
        <el-form :inline="true" :model="process" ref="process" @keyup.enter.native="search">
          <el-form-item prop="processState" label="流程状态">
            <el-select v-model="process.processState" @change="search" placeholder="请选择流程状态" clearable>
              <el-option
                v-for="option in processStates"
                :key="option.key"
                :value="option.key"
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字" prop="keyword">
            <el-input v-model="process.keyword" placeholder="请输入关键字" clearable/>
          </el-form-item>
          <!--操作按钮-->
          <el-form-item class="process-operation-buttons">
            <el-button @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table class="table-list" :data="items" v-loading="loading" height="100%">
          <el-table-column property="processTitle" label="流程信息" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column
            property="startedTime"
            label="开始时间"
            :formatter="formatDate"
            align="center">
          </el-table-column>
          <el-table-column
            property="endTime"
            label="结束时间"
            :formatter="formatDate"
            align="center">
          </el-table-column>
          <el-table-column property="taskName" label="当前节点" align="center"></el-table-column>
          <el-table-column property="taskAssignee" label="当前处理人" align="center"></el-table-column>
          <el-table-column property="status" label="流程状态" align="center"></el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="viewTask(scope.row,'viewAll')">查看</el-button>
              <el-button type="text" @click="endProcessTask(scope.row)" :disabled="scope.row.status==='已终止'">终止</el-button>
              <el-button type="text" @click="stateView(scope.row)">状态</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-footer height="32px" class="pagination-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          ></el-pagination>
        </el-footer>
        <approval-comment
          :dialogVisible="commentVisible"
          :approvalCommentHistory="approvalCommentHistory"
          :currentNodeId="currentNodeId"
          @close="commentVisible=false"
          @viewState="viewTask"></approval-comment>
      </div>
    </el-main>
    <dialog-form-runtime @openDialog="openDialog" :formRuntimeDialog="formRuntimeDialog"></dialog-form-runtime>
  </el-container>
</template>

<script>
import moment from 'moment'
import ApprovalComment from './approval-comment'
import {processtMixin, processViewMixin} from './mixin'
import DialogFormRuntime from '@/components/shared/dialog-form-runtime.vue'
export default {
  components: {
    ApprovalComment,
    DialogFormRuntime
  },
  mixins: [processtMixin, processViewMixin],
  name: 'ProcessHasInstances',
  provide () {
    return {
      initCount: this.initCount
    }
  },
  data () {
    return {
      process: {processName: '', keyword: '', processState: ''},
      processStates: [{
        text: '全部'
      }, {
        key: '1',
        text: '进行中'
      }, {
        key: '2',
        text: '已完成'
      }, {
        key: '3',
        text: '已终止'
      }, {
        key: '4',
        text: '已作废'
      }],
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      instanceId: '',
      filters: {},
      initCount: {value: 0},
      showOpenDialog: false
    }
  },
  watch: {
    'pagination.currentPage' (val) {
      this.getTableData()
    },
    'pagination.pageSize' (val) {
      this.getTableData()
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    search () {
      this.pagination.currentPage = 1
      this.filters = {
        'keyword': this.process.keyword,
        'processState': this.process.processState
      }
      this.getTableData()
    },
    viewTask (row, type) {
      if (type) {
        this.$router.push({ name: 'process-view', params: { instanceId: row.id, nodeId: row.nodeId } })
      } else {
        //  状态中的查看
        this.$router.push({ name: 'process-view', params: { instanceId: this.approvalInstanceId, currentNodeId: row, nodeId: row.nodeId } })
        this.showOpenDialog = true
        this.commentVisible = false
      }
    },
    openDialog () {
      if (this.showOpenDialog) {
        this.commentVisible = true
        this.showOpenDialog = false
      }
    },
    endProcessTask (row) {
    // 通过状态找到是否有处理人
      this.$axios.get(`/process-api/runtime/dealRecord?taskId=${row.id}`)
        .then((res) => {
          let list = []
          let userIds = []
          res.data.forEach(m => {
            m.date && list.push(m.date)
            m.date && userIds.push(m.userId)
          })
          userIds.push(res.data[res.data.length - 1].userId)
          let firstTask = res.data[0]
          let lastTask = res.data[res.data.length - 1]
          // 大于1条就是代表有人处理过，无法终止
          // 发起人返回中途无其他人员处理也可以终止
          if ((Array.from(new Set(userIds)).length === 1 && firstTask.nodeId === lastTask.nodeId) || list.length <= 1) {
            this.$confirm('是否终止当前流程实例任务？', '终止流程', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              center: true,
              customClass: 'publishMessageBox urgeMessageBox'
            }).then(() => {
              this.$axios.post(`/process-api/runtime/endProcessTask?instanceId=${row.id}`)
                .then((res) => {
                  this.$message({
                    showClose: true,
                    message: '流程终止成功',
                    type: 'success'
                  })
                  this.getTableData()
                })
            }).catch(() => {
            })
          } else {
            this.$message.error('流程正在被其他人处理，不能终止，可联系系统管理员终止')
          }
        })
    },
    formatDate (row, column) {
      var data = row[column.property]
      if ((column.property === 'startedTime' || column.property === 'endTime') && data) {
        return moment(data).format('YYYY-MM-DD HH:mm')
      }
      return data
    },
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      params.filters = this.filters
      this.$axios.get('/process-api/runtime/startedInstances/count', {params})
        .then((res) => {
          this.pagination.total = res.data
          if ((this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
          }
        })
      this.$axios.get('/process-api/runtime/startedInstances', {params})
        .then((res) => {
          this.items = res.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss'
</style>



// WEBPACK FOOTER //
// src/components/process/runtime/process-hasInstances.vue